module.exports = __webpack_public_path__ + "img/share-insta.92fefbb2.png";